import { CompensationMethodType } from "@redotech/cockroachdb-codegen/congodb/compensation-method-type";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** Which card icon a compensation method renders. */
export const PosCompensationIconSchema = z.enum([
  "refund",
  "store_credit",
  "shop_now",
  "repair",
]);
export type PosCompensationIcon = z.infer<typeof PosCompensationIconSchema>;

/** The adjustment badge shown on the right of a method card (bonus vs fee). */
export const PosCompensationBadgeSchema = z.object({
  text: z.string(),
  positive: z.boolean(),
});

/** One offered compensation method, display-ready for the POS method card. */
export const PosCompensationMethodSchema = z.object({
  type: createEnum(CompensationMethodType),
  iconType: PosCompensationIconSchema,
  title: z.string(),
  subtitle: z.string(),
  rightTitle: PosCompensationBadgeSchema.nullable(),
  /** Advisory shown when this method is the selected one (null = suppressed). */
  payerAdvisoryText: z.string().nullable(),
});

/** Display-ready POS choose-compensation-method state. */
export const PosCompensationViewSchema = z.object({
  texts: z.object({ titleText: z.string(), subtitleText: z.string() }),
  methods: z.array(PosCompensationMethodSchema),
  cashPaymentText: z.string().nullable(),
});

export type PosCompensationView = z.infer<typeof PosCompensationViewSchema>;
export type PosCompensationMethod = z.infer<typeof PosCompensationMethodSchema>;

export const getPosCompensationView = {
  name: "getPosCompensationView" as const,
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({ view: PosCompensationViewSchema }),
};
